export default __webpack_public_path__ + "static/media/114t.4acd428d.jpg";